import { createContextLogger } from './utils/logger';

const logger = createContextLogger('config');

// Type definition for environment variables
interface ImportMetaEnv {
  readonly VITE_API_BASE_URL?: string;
  readonly VITE_SCHEDULER_BASE_URL?: string;
  readonly DEV: boolean;
  readonly PROD: boolean;
  readonly SSR: boolean;
}

interface ImportMeta {
  readonly env: ImportMetaEnv;
}

// API Configuration
// Check for environment variables in order of preference:
// 1. Vite environment variable (VITE_API_BASE_URL)
// 2. System environment variable (VITE_API_BASE_URL)
// 3. Default fallback
export const API_BASE_URL: string = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080';

// Scheduler Configuration
// Check for environment variables in order of preference:
// 1. Vite environment variable (VITE_SCHEDULER_BASE_URL)
// 2. System environment variable (VITE_SCHEDULER_BASE_URL)
// 3. Default fallback
export const SCHEDULER_BASE_URL: string = import.meta.env.VITE_SCHEDULER_BASE_URL || 'http://localhost:8085';

// Log the current configuration for debugging
logger.debug('API Configuration:', {
  viteEnv: import.meta.env.VITE_API_BASE_URL,
  schedulerViteEnv: import.meta.env.VITE_SCHEDULER_BASE_URL,
  apiUrl: API_BASE_URL,
  schedulerUrl: SCHEDULER_BASE_URL,
});
